import request from '@/utils/request'

const siteManage = {
  name: 'siteManage',
  state: {
    isDetailLoading: false,
    siteDetailData: {},
    siteGoodsDetailData: {}
  },

  mutations: {
    SET_IS_MODULES_SITE_DETAIL_LOADING: (state, data) => {
      state.isDetailLoading = data
    },
    SET_MODULES_SITE_DETAIL_DATA: (state, data) => {
      state.siteDetailData = data
    },
    SET_MODULES_SITE_GOODS_DETAIL_DATA: (state, data) => {
      state.siteGoodsDetailData = data
    }
  },

  actions: {
    // 重置站点详情数据
    resetSiteDetailData({ commit }) {
      commit('SET_MODULES_SITE_DETAIL_DATA', {})
    },
    // 设置站点详情数据
    setSiteDetailData({ commit }, data) {
      commit('SET_MODULES_SITE_DETAIL_DATA', data)
    },
    // 设置站点商品详情数据
    setSiteGoodsDetailData({ commit }, data) {
      commit('SET_MODULES_SITE_GOODS_DETAIL_DATA', data)
    },
    // 加载社区下拉列表
    querySiteListNoPageList({ commit }, communityId, isAll) {
      return new Promise((resolve, reject) => {
        request({
          url: '/modules/site/siteListNoPage',
          method: 'post',
          data: {
            communityId: communityId
          }
        }).then(response => {
          for (const item of response.data) {
            item.label = item.name
            item.value = item.id
          }
          if (isAll) {
            response.data.unshift({label: '全部', value: ''})
          }
          resolve(response.data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default siteManage
